export default "__VITE_ASSET__CifGFzQy__"